/**
 * Article rédigé le 2026-09-06 à partir de sources web ouvertes et vérifiées automatiquement
 * (6 URL testées, révisé après vérification). Daté au moment des faits : 2025-06-06.
 * À relire avant/après mise en ligne. Format : voir src/blog/README.md
 */
export default {
  "slug": "isifc-nouveau-batiment-inaugure-2025",
  "title": "L'ISIFC inaugure 1 500 m² pour doubler son école d'ingénieurs biomédicale",
  "excerpt": "Le 4 juin, l'ISIFC a inauguré plus de 1 500 m² neufs sur le campus Bouloie-Temis : sept millions d'euros, quatre partenaires publics, et l'ambition de doubler les effectifs d'ici 2028.",
  "seoTitle": "ISIFC : 1 500 m² neufs sur le campus Bouloie",
  "seoDescription": "L'école d'ingénieurs biomédicale ISIFC a inauguré le 4 juin 2025 plus de 1 500 m² sur le campus Bouloie-Temis : sept millions d'euros, 300 étudiants visés.",
  "category": "formation",
  "tags": [
    "ISIFC",
    "Bouloie-Temis",
    "Dispositifs médicaux",
    "E-santé",
    "Grand Besançon Métropole"
  ],
  "author": "jimmy",
  "publishedAt": "2025-06-06",
  "updatedAt": "2025-06-06",
  "featured": false,
  "cover": {
    "image": "/img/blog/besancon-le-batiment-des-propedeutiques-de-l-ufr-des-science.jpg",
    "credit": "Photo : Besançon, le bâtiment des Propédeutiques de l'UFR des Sciences et Techniques — Wikipedro, CC BY-SA 4.0, via Wikimedia Commons",
    "alt": "Le bâtiment des Propédeutiques de l'UFR Sciences et Techniques sur le campus de la Bouloie à Besançon, sa façade de pierre dorée percée de larges fenêtres et sa cage d'escalier vitrée, ouvrant sur un vaste parvis sous un ciel bleu"
  },
  "content": [
    {
      "type": "lead",
      "text": "Mercredi 4 juin, l'Institut supérieur d'ingénieurs de Franche-Comté (ISIFC) a inauguré son nouveau bâtiment, au cœur du campus Bouloie-Temis à Besançon. Plus de 1 500 m² neufs, financés par quatre partenaires publics, pour la seule école d'ingénieurs française entièrement consacrée aux dispositifs médicaux. L'objectif affiché : doubler les effectifs pour atteindre 300 étudiants en 2028."
    },
    {
      "type": "keyfacts",
      "facts": [
        {
          "label": "Quoi",
          "value": "Inauguration du nouveau bâtiment de l'ISIFC, plus de 1 500 m²"
        },
        {
          "label": "Quand",
          "value": "Mercredi 4 juin 2025, à partir de 14 h (accueil presse dès 13 h 45)"
        },
        {
          "label": "Où",
          "value": "Campus Bouloie-Temis, Besançon"
        },
        {
          "label": "Qui",
          "value": "ISIFC, Université Marie et Louis Pasteur, Région Bourgogne-Franche-Comté, Grand Besançon Métropole, Département du Doubs"
        },
        {
          "label": "Pour qui",
          "value": "Étudiants en génie biomédical et industriels des technologies médicales"
        }
      ]
    },
    {
      "type": "h2",
      "text": "Une architecture pensée comme un outil pédagogique"
    },
    {
      "type": "p",
      "text": "L'inauguration s'est tenue en présence de Vincent Armbruster, directeur de l'ISIFC, de Marie-Guite Dufay, présidente de la Région Bourgogne-Franche-Comté, d'Anne Vignot, présidente de Grand Besançon Métropole, et d'Hugues Daussy, président de l'Université Marie et Louis Pasteur[^2]. La journée a enchaîné accueil sur le parvis, visite guidée du bâtiment, table ronde consacrée à la « Performance des dispositifs médicaux : quand la technologie répond à de nouveaux besoins », puis allocutions officielles[^1]."
    },
    {
      "type": "p",
      "text": "Construit sur un terrain entièrement vierge, l'édifice est signé de l'agence Dominique Coulon & Associés. Il joue d'une dualité de volumes : un corps en béton teinté dans la masse, dont les aspérités doivent accueillir à terme des mousses naturelles rappelant le site boisé, et, à l'est, un volume vitré qui abrite l'amphithéâtre et une grande salle de cours modulable[^1]. Les 1 500 m² se répartissent sur trois niveaux et comptent seize salles de cours flexibles et à usages multiples[^2]."
    },
    {
      "type": "p",
      "text": "Le parti pris est explicitement fonctionnel : des parois mobiles permettent de fusionner l'amphithéâtre et la salle d'exposition en quelques minutes, et le programme intègre salles projet, zones de prototypage, salles techniques et plateformes pédagogiques[^1]. Vincent Armbruster a rappelé que les anciens locaux, devenus « étriqués », ne suivaient plus la croissance de l'école, et a présenté le nouveau bâtiment comme un « véritable outil pédagogique » capable de s'adapter aux usages à venir[^2]. Avant ce déménagement, l'ISIFC occupait environ 1 080 m²[^4]."
    },
    {
      "type": "h2",
      "text": "Sept millions d'euros, quatre financeurs"
    },
    {
      "type": "p",
      "text": "Le coût total de l'opération s'établit à 7 023 373 euros toutes dépenses confondues, hors taxes, selon le dossier de presse des financeurs[^1] ; la presse locale a fait état d'un investissement de 8,4 millions d'euros, un écart qui correspond vraisemblablement au périmètre retenu[^2]. La répartition entre partenaires publics est la suivante[^1] :"
    },
    {
      "type": "ul",
      "items": [
        "**Région Bourgogne-Franche-Comté** : 3 268 550 € (46,54 %)",
        "**Université Marie et Louis Pasteur** : 1 798 546 € (25,61 %)",
        "**Grand Besançon Métropole** : 1 742 277 € (24,81 %)",
        "**Département du Doubs** : 214 000 € (3,05 %)"
      ]
    },
    {
      "type": "p",
      "text": "Ce chantier n'est pas isolé. Il s'inscrit dans la transformation du campus Bouloie-Temis, qui mobilise près de 80 millions d'euros d'ici 2027 sur le plus grand campus de Franche-Comté, fréquenté par plus de 10 000 étudiants[^1]. Le programme d'ensemble prévoit plus de 65 000 m² d'aménagements paysagers, 40 000 m² de bâtiments créés ou rénovés et 2,7 km de cheminements piétons et cyclables[^6]."
    },
    {
      "type": "h2",
      "text": "Doubler les effectifs d'ici 2028"
    },
    {
      "type": "p",
      "text": "L'ISIFC, créé en 2001 et intégré à l'Université Marie et Louis Pasteur, forme aujourd'hui une soixantaine d'ingénieurs par an en génie biomédical[^1][^5]. L'école revendique une triple culture rare — technique, réglementaire et médicale — et un cursus de trois ans habilité par la Commission des titres d'ingénieur, doublé du label européen EUR-ACE[^1]. Le nouveau bâtiment doit permettre de doubler les effectifs, avec un objectif de 300 étudiants en 2028[^1] ; le calendrier du campus programme d'ailleurs la livraison d'un second bâtiment ISIFC en 2027[^1], la page du projet évoquant pour sa part une extension à l'horizon 2028[^6]."
    },
    {
      "type": "p",
      "text": "La demande, elle, est déjà là. Plus de 82 % des diplômés trouvent un emploi dans les deux mois, dont 27 % en Bourgogne-Franche-Comté, 24 % en Auvergne-Rhône-Alpes et 17 % en Suisse[^5]. L'école a par ailleurs lancé, avec ses partenaires universitaires et professionnels, le projet ARCliMeD (Affaires réglementaires et cliniques pour l'industrie du dispositif médical), qui vise à former un millier de spécialistes en cinq ans dans le cadre de France 2030, avec huit universités partenaires[^5]. En mai, elle a également créé une chaire de mécénat « Technologie pour la santé » avec les entreprises STATICE et DIXI Medical comme membres fondateurs, appuyée par la Fondation FC'INNOV[^1]."
    },
    {
      "type": "h2",
      "text": "L'e-santé et l'IA déjà dans le cursus"
    },
    {
      "type": "p",
      "text": "En troisième année, l'ISIFC propose quatre options de spécialité : biomécanique et microsystèmes, bio-ingénierie, microrobotique en santé et e-santé[^1]. Cette dernière, créditée de 10 ECTS au semestre 5, consacre son module le plus lourd à [l'intelligence artificielle appliquée à la santé](/blog/besancon-terrain-naturel-ia-sante-chu-isifc-temis)[^3] :"
    },
    {
      "type": "ul",
      "items": [
        "**Intelligence artificielle** (4 ECTS) : deep learning et analyse de données, algorithmes génétiques, systèmes multi-agents[^3]",
        "**Systèmes d'information de santé** (2 ECTS) : plateformes de télémédecine, serveurs PACS et normes d'interopérabilité HL7, IHE et DICOM[^3]",
        "**Analyse d'images** (1 ECTS) : traitement d'images médicales sous MATLAB/Octave[^3]",
        "**CryptoSecu** (1 ECTS) et **RESOCOM** (2 ECTS) : sécurisation des données médicales, réseaux, cloud et objets connectés en santé[^3]"
      ]
    },
    {
      "type": "p",
      "text": "Autrement dit, les compétences en apprentissage automatique ne sont pas ici un supplément d'âme mais un bloc identifié du diplôme, adossé à une culture réglementaire et clinique — précisément la combinaison que réclame le marquage des dispositifs médicaux intégrant de l'IA."
    },
    {
      "type": "callout",
      "tone": "tip",
      "title": "Pourquoi ça compte pour Besançon",
      "text": "Le bassin bisontin ne manque pas de laboratoires ni d'entreprises Medtech : [FEMTO-ST](/blog/femto-st-besancon-capitale-microtechniques), le CHU, l'EFS, le Pôle des Microtechniques, l'incubateur [TEMIS](/blog/temis-technopole-startups-deeptech-besancon)[^1]. Ce qui limitait la croissance de la filière, c'était le nombre d'ingénieurs formés sur place. Doubler les effectifs pour atteindre 300 étudiants change l'échelle du vivier local, au moment où les dispositifs médicaux embarquent de plus en plus de logiciel et d'apprentissage automatique."
    },
    {
      "type": "h2",
      "text": "Un pari sur la décennie"
    },
    {
      "type": "p",
      "text": "Reste que l'inauguration d'un bâtiment ne fait pas une montée en puissance. Le doublement des effectifs suppose un second bâtiment, des recrutements enseignants et un flux de candidatures à la hauteur. Les partenaires publics ont posé la première brique ; les prochaines années diront si l'objectif de 2028 tient. Pour l'heure, Besançon dispose d'un équipement neuf, ouvert sur la forêt et sur l'industrie, au milieu d'un campus en chantier depuis 2021[^1][^6]."
    }
  ],
  "references": [
    {
      "id": 1,
      "title": "Dossier de presse — Inauguration du nouveau bâtiment de l'Institut supérieur d'ingénieurs de Franche-Comté (ISIFC)",
      "publisher": "Grand Besançon Métropole",
      "url": "https://www.grandbesancon.fr/wp-content/uploads/sites/2/2025/06/2025_DP_ISIFC_web2.pdf",
      "type": "official",
      "date": "2025-06-04"
    },
    {
      "id": 2,
      "title": "Un nouveau bâtiment au service de l'apprentissage pour l'ISIFC",
      "publisher": "macommune.info",
      "url": "https://www.macommune.info/un-nouveau-batiment-au-service-de-lapprentissage-pour-lisifc/",
      "type": "press",
      "date": "2025-06-05"
    },
    {
      "id": 3,
      "title": "Option de spécialisation : e-Santé",
      "publisher": "ISIFC — Université Marie et Louis Pasteur",
      "url": "https://isifc.univ-fcomte.fr/isifc-loption-e-sante/",
      "type": "official",
      "date": ""
    },
    {
      "id": 4,
      "title": "Le chantier des futurs locaux de l'école avance !",
      "publisher": "ISIFC — Université Marie et Louis Pasteur",
      "url": "https://isifc.univ-fcomte.fr/le-chantier-des-futurs-locaux-de-lecole-avance/",
      "type": "official",
      "date": ""
    },
    {
      "id": 5,
      "title": "L'ISIFC s'agrandit pour relever les défis du secteur des dispositifs médicaux",
      "publisher": "DeviceMed",
      "url": "https://www.devicemed.fr/dossiers/actualites/vie-des-entreprises/lisifc-sagrandit-pour-relever-les-defis-du-secteur-des-dispositifs-medicaux/50404",
      "type": "press",
      "date": "2025-05-13"
    },
    {
      "id": 6,
      "title": "Campus Bouloie-Temis — le projet de transformation",
      "publisher": "Ville de Besançon / Grand Besançon Métropole",
      "url": "https://bouloietemis.besancon.fr/",
      "type": "official",
      "date": ""
    }
  ]
};
